import React, { useEffect, useState } from "react";
import { Button, Popconfirm, Table, Tag } from "antd";
import { del, get } from "../../api/axios";
import { Pagination, message } from "antd";

const HolidaysPrices = () => {
  const columns = [
    {
      title: " الرقم   ",
      dataIndex: "id",
    },
    {
      title: "  رقم الطلب  ",
      dataIndex: "request_number",
    },
    {
      title: "  تاريخ الطلب ",
      dataIndex: "request_date",
    },
    {
      title: " اسم الاجازة   ",
      dataIndex: "name",
    },
    {
      title: " كود الوحدة  ",
      dataIndex: "property_id",
    },
    {
      title: "  تاريخ البداية ",
      dataIndex: "start_date",
    },
    {
      title: "  تاريخ النهاية ",
      dataIndex: "end_date",
    },

    {
      title: " النوع  ",
      dataIndex: "type",
    },
    {
      title: "السعر",
      children: [
        {
          title: " الخميس ",
          dataIndex: "prices",
          render: ({ thu }) => <>{thu}</>,
        },
        {
          title: " الجمعة ",
          dataIndex: "prices",
          render: ({ fri }) => <>{fri}</>,
        },
        {
          title: " السبت ",
          dataIndex: "prices",
          render: ({ sat }) => <>{sat}</>,
        },
        {
          title: " وسط الاسبوع ",
          dataIndex: "prices",
          render: ({ rest_of_week }) => <>{rest_of_week}</>,
        },
      ],
    },
    {
      title: "  حالة الطلب  ",
      render: ({ status }) => (
        <>
          <Tag color={`${status == "منتهي" ? "success" : "error"}`}>
            {status}
          </Tag>
        </>
      ),
    },
  ];

  const [data, setdata] = useState([]);
  const [loading, setLoading] = useState(true);

  const [total, setTotal] = useState(1);

  useEffect(() => {
    get("get-holidays-prices").then((res) => {
      setdata(res.data.data);
      setTotal(res.data.meta.last_page);
      setLoading(false);
    });
  }, []);

  const handlePagination = (pageNumber) => {
    setLoading(true);

    get(`get-holidays-prices?page=${pageNumber}`).then((res) => {
      setdata(res.data.data);
      setLoading(false);
    });
  };

  return (
    <div>
      <div className="row">
        <div className="col-12 grid-margin stretch-card">
          <div className="w-100">
            <Table
              locale={{ emptyText: "لا يوجد عناصر" }}
              loading={loading}
              pagination={false}
              bordered
              columns={columns}
              dataSource={data}
              size="middle"
              scroll={{
                y: "65vh",
              }}
            />
            <Pagination
              defaultCurrent={1}
              className="mt-4 d-flex align-items-center justify-content-center"
              position="bottomCenter"
              total={total * 10}
              onChange={handlePagination}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HolidaysPrices;
